export function generateSchema(coverageTypes) {
  var primaryFields = [];
  var additionalFields = [];

  // Temp casco variables for custom validation
  // Only available in primary fields
  var firstCascoIndex;
  var lastCasco;

  for (var coverage of coverageTypes) {
    var newField = {
      type: "bvm-checkbox",
      help: `coverage_change_request_form_${coverage.code}_help`,
      model: coverage.code,
      label: coverage.description
    }

    if (coverage.casco) {
      if (firstCascoIndex === undefined) {
        firstCascoIndex = primaryFields.length;
      }

      newField.xorErrorMessage = "coverage_change_request_validation_casco_error";
      newField.validator = ["bvmCheckboxXOR"];
      newField.xorFieldCheck = lastCasco ? lastCasco.code : undefined; // Set later

      lastCasco = coverage;
    }

    if (coverage.primary) {
      primaryFields.push(newField);
    } else {
      additionalFields.push(newField);
    }
  }

  // Check if multiple casco's where available
  // If so, set first to last. No more then one casco is allowed be selected.
  if (primaryFields[firstCascoIndex].model != lastCasco.code) {
    primaryFields[firstCascoIndex].xorFieldCheck = lastCasco.code;
  }

  return {
    groups: [{
      legend: "coverage_change_request_form_group_primary",
      fields: primaryFields
    }, {
      legend: "coverage_change_request_form_group_additional",
      fields: additionalFields
    }]
  };
}